import { StateType } from '../../types';

export const getPaymentDetails = (state: StateType) => state.deferredPayments.paymentDetails.data;
export const getPaymentDetailsError = (state: StateType) =>
  state.deferredPayments.paymentDetails.error;
